// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{overflow-y:auto}#__layout,#__nuxt,.v-application,.v-application--wrap,html{height:100%}.v-application--wrap{min-height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
